import React from 'react';
import { withRouter } from 'react-router-dom';

import { VpInput } from '../../';
import { getQueryParamMap, updateQueryString } from '../../../utils';
import { useDebounce } from '../../../hooks';

const queryKey = 'searchParam';

export const VpSubmissionSearchInput = withRouter(({ history, ...rest }) => {
  const defaultValue = getQueryParamMap(history)?.[queryKey];

  const onChangeDebounce = useDebounce((value) => {
    updateQueryString(history, { [queryKey]: value ? value : undefined });
  }, 500);

  const onChange = ({ target }) => {
    const value = target?.value || '';
    onChangeDebounce(value);
  };

  return (
    <VpInput
      maxLength={50}
      name="submissionSearch"
      placeholder="Search"
      startIcon="Search"
      onChange={onChange}
      defaultValue={defaultValue}
      {...rest}
    />
  );
});

export default VpSubmissionSearchInput;



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/campaign-submissions/VpSubmissionSearchInput.jsx